import { abbreviateNumber, financialFormatter } from '../lib/utils'

import * as COLORS from './colors'
import * as FONTS from './fonts'
import * as SPACING from './spacing'

export { COLORS, FONTS, SPACING }

export const BASE_URL = process.env.REACT_APP_API_ENDPOINT

// export const TINYMCE_APIKEY = process.env.REACT_APP_TINYMCE_APIKEY
export const EMPLOYEE_RESOURCE = '/employee'
export const USERS_RESOURCE = '/users'
export const FORGET_PASSWORD_RESOURCE = '/forgetpassword'
export const ROLE_RESOURCE = '/role'
export const MODULE_RESOURCE = '/module'
export const ROLE_MODULE_MAPPING_RESOURCE = '/role-module-mapping'

export const SHOW_MODAL = 'SHOW_MODAL'
export const HIDE_MODAL = 'HIDE_MODAL'
export const SHOW_CONFIRM = 'SHOW_CONFIRM'
export const HIDE_CONFIRM = 'HIDE_CONFIRM'

export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const LOGIN_RESET = 'LOGIN_RESET'
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST'
export const AUTH_OPEN_RESPONSE_MODAL = 'AUTH_OPEN_RESPONSE_MODAL'

export const FAVORITE_REQUEST = 'FAVORITE_REQUEST'
export const FAVORITE_SUCCESS = 'FAVORITE_SUCCESS'
export const FAVORITE_FAILURE = 'FAVORITE_FAILURE'
export const FAVORITE_RESET = 'FAVORITE_RESET'

export const COLLAPSE_SIDEBAR_REQUEST = 'COLLAPSE_SIDEBAR_REQUEST'
export const COLLAPSE_SIDEBAR_RESET = 'COLLAPSE_SIDEBAR_RESET'
export const DOCKED_SIDEBAR_DESKTOP = 'DOCKED_SIDEBAR_DESKTOP'
export const DOCKED_SIDEBAR_MOBILE = 'DOCKED_SIDEBAR_MOBILE'

export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_FAILURE = 'AUTH_FAILURE'
export const AUTH_RESET = 'AUTH_RESET'

export const MASTER_DATA_GET_REQUEST = 'MASTER_DATA_GET_REQUEST'
export const MASTER_DATA_GET_SUCCESS = 'MASTER_DATA_GET_SUCCESS'
export const MASTER_DATA_GET_FAILURE = 'MASTER_DATA_GET_FAILURE'

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST'
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE'
export const CHANGE_PASSWORD_RESET = 'CHANGE_PASSWORD_RESET'

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE'
export const RESET_PASSWORD_RESET = 'RESET_PASSWORD_RESET'

export const LOB_CREATE_REQUEST = 'LOB_CREATE_REQUEST'
export const LOB_CREATE_SUCCESS = 'LOB_CREATE_SUCCESS'
export const LOB_CREATE_FAILURE = 'LOB_CREATE_FAILURE'
export const LOB_CREATE_RESET = 'LOB_CREATE_RESET'

export const LOB_GET_REQUEST = 'LOB_GET_REQUEST'
export const LOB_GET_SUCCESS = 'LOB_GET_SUCCESS'
export const LOB_GET_FAILURE = 'LOB_GET_FAILURE'
export const LOB_GET_RESET = 'LOB_GET_RESET'

export const LOB_LIST_REQUEST = 'LOB_LIST_REQUEST'
export const LOB_LIST_SUCCESS = 'LOB_LIST_SUCCESS'
export const LOB_LIST_FAILURE = 'LOB_LIST_FAILURE'
export const LOB_LIST_RESET = 'LOB_LIST_RESET'

export const LOB_EDIT_REQUEST = 'LOB_EDIT_REQUEST'
export const LOB_EDIT_SUCCESS = 'LOB_EDIT_SUCCESS'
export const LOB_EDIT_FAILURE = 'LOB_EDIT_FAILURE'
export const LOB_EDIT_RESET = 'LOB_EDIT_RESET'

export const LOB_DEACTIVATE_REQUEST = 'LOB_DEACTIVATE_REQUEST'
export const LOB_DEACTIVATE_SUCCESS = 'LOB_DEACTIVATE_SUCCESS'
export const LOB_DEACTIVATE_FAILURE = 'LOB_DEACTIVATE_FAILURE'
export const LOB_DEACTIVATE_RESET = 'LOB_DEACTIVATE_RESET'

export const LOB_EXPORT_REQUEST = 'LOB_EXPORT_REQUEST'
export const LOB_EXPORT_SUCCESS = 'LOB_EXPORT_SUCCESS'
export const LOB_EXPORT_FAILURE = 'LOB_EXPORT_FAILURE'
export const LOB_EXPORT_RESET = 'LOB_EXPORT_RESET'

export const USER_EXPORT_REQUEST = 'USER_EXPORT_REQUEST'
export const USER_EXPORT_SUCCESS = 'USER_EXPORT_SUCCESS'
export const USER_EXPORT_FAILURE = 'USER_EXPORT_FAILURE'
export const USER_EXPORT_RESET = 'USER_EXPORT_RESET'

export const USER_IMPORT_REQUEST = 'USER_IMPORT_REQUEST'
export const USER_IMPORT_SUCCESS = 'USER_IMPORT_SUCCESS'
export const USER_IMPORT_FAILURE = 'USER_IMPORT_FAILURE'
export const USER_IMPORT_RESET = 'USER_IMPORT_RESET'

export const USER_CREATE_REQUEST = 'USER_CREATE_REQUEST'
export const USER_CREATE_SUCCESS = 'USER_CREATE_SUCCESS'
export const USER_CREATE_FAILURE = 'USER_CREATE_FAILURE'
export const USER_CREATE_RESET = 'USER_CREATE_RESET'

export const USER_GET_REQUEST = 'USER_GET_REQUEST'
export const USER_GET_SUCCESS = 'USER_GET_SUCCESS'
export const USER_GET_FAILURE = 'USER_GET_FAILURE'
export const USER_GET_RESET = 'USER_GET_RESET'

export const USER_LIST_REQUEST = 'USER_LIST_REQUEST'
export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS'
export const USER_LIST_FAILURE = 'USER_LIST_FAILURE'
export const USER_LIST_RESET = 'USER_LIST_RESET'

export const USER_EDIT_REQUEST = 'USER_EDIT_REQUEST'
export const USER_EDIT_SUCCESS = 'USER_EDIT_SUCCESS'
export const USER_EDIT_FAILURE = 'USER_EDIT_FAILURE'
export const USER_EDIT_RESET = 'USER_EDIT_RESET'

export const USER_EDIT_PROFILE_REQUEST = 'USER_EDIT_PROFILE_REQUEST'
export const USER_EDIT_PROFILE_SUCCESS = 'USER_EDIT_PROFILE_SUCCESS'
export const USER_EDIT_PROFILE_FAILURE = 'USER_EDIT_PROFILE_FAILURE'
export const USER_EDIT_PROFILE_RESET = 'USER_EDIT_PROFILE_RESET'

export const USER_DEACTIVATE_REQUEST = 'USER_DEACTIVATE_REQUEST'
export const USER_DEACTIVATE_SUCCESS = 'USER_DEACTIVATE_SUCCESS'
export const USER_DEACTIVATE_FAILURE = 'USER_DEACTIVATE_FAILURE'
export const USER_DEACTIVATE_RESET = 'USER_DEACTIVATE_RESET'

export const USER_UPLOAD_IMAGE_REQUEST = 'USER_UPLOAD_IMAGE_REQUEST'
export const USER_UPLOAD_IMAGE_SUCCESS = 'USER_UPLOAD_IMAGE_SUCCESS'
export const USER_UPLOAD_IMAGE_FAILURE = 'USER_UPLOAD_IMAGE_FAILURE'
export const USER_UPLOAD_IMAGE_RESET = 'USER_UPLOAD_IMAGE_RESET'

export const USER_OPEN_RESPONSE_MODAL = 'USER_OPEN_RESPONSE_MODAL'
export const USER_SET_KEYWORD_SEARCH = 'USER_SET_KEYWORD_SEARCH'
export const USER_SET_EDIT_PERSONAL = 'USER_SET_EDIT_PERSONAL'
export const USER_SET_EDIT_COMPANY = 'USER_SET_EDIT_COMPANY'
export const USER_SET_EDIT_ROLE = 'USER_SET_EDIT_ROLE'
export const USER_SET_EDIT_MOVEMENT = 'USER_SET_EDIT_MOVEMENT'

export const USER_CREATE_MOVEMENT_REQUEST = 'USER_CREATE_MOVEMENT_REQUEST'
export const USER_CREATE_MOVEMENT_SUCCESS = 'USER_CREATE_MOVEMENT_SUCCESS'
export const USER_CREATE_MOVEMENT_FAILURE = 'USER_CREATE_MOVEMENT_FAILURE'
export const USER_CREATE_MOVEMENT_RESET = 'USER_CREATE_MOVEMENT_RESET'

export const USER_EDIT_MOVEMENT_REQUEST = 'USER_EDIT_MOVEMENT_REQUEST'
export const USER_EDIT_MOVEMENT_SUCCESS = 'USER_EDIT_MOVEMENT_SUCCESS'
export const USER_EDIT_MOVEMENT_FAILURE = 'USER_EDIT_MOVEMENT_FAILURE'
export const USER_EDIT_MOVEMENT_RESET = 'USER_EDIT_MOVEMENT_RESET'

export const USER_DELETE_MOVEMENT_REQUEST = 'USER_DELETE_MOVEMENT_REQUEST'
export const USER_DELETE_MOVEMENT_SUCCESS = 'USER_DELETE_MOVEMENT_SUCCESS'
export const USER_DELETE_MOVEMENT_FAILURE = 'USER_DELETE_MOVEMENT_FAILURE'
export const USER_DELETE_MOVEMENT_RESET = 'USER_DELETE_MOVEMENT_RESET'

export const USER_EDIT_PRIVILEGE_ROLE_REQUEST = 'USER_EDIT_PRIVILEGE_ROLE_REQUEST'
export const USER_EDIT_PRIVILEGE_ROLE_SUCCESS = 'USER_EDIT_PRIVILEGE_ROLE_SUCCESS'
export const USER_EDIT_PRIVILEGE_ROLE_FAILURE = 'USER_EDIT_PRIVILEGE_ROLE_FAILURE'
export const USER_EDIT_PRIVILEGE_ROLE_RESET = 'USER_EDIT_PRIVILEGE_ROLE_RESET'

export const SHOW_MANUAL_USER = 'SHOW_MANUAL_USER'
export const CLOSE_MANUAL_USER = 'CLOSE_MANUAL_USER'

export const EMPLOYEE_LEVELS_GET_REQUEST = 'EMPLOYEE_LEVELS_GET_REQUEST'
export const EMPLOYEE_LEVELS_GET_SUCCESS = 'EMPLOYEE_LEVELS_GET_SUCCESS'
export const EMPLOYEE_LEVELS_GET_FAILURE = 'EMPLOYEE_LEVELS_GET_FAILURE'
export const EMPLOYEE_LEVELS_GET_RESET = 'EMPLOYEE_LEVELS_GET_RESET'

export const EMPLOYEE_LEVELS_LIST_REQUEST = 'EMPLOYEE_LEVELS_LIST_REQUEST'
export const EMPLOYEE_LEVELS_LIST_SUCCESS = 'EMPLOYEE_LEVELS_LIST_SUCCESS'
export const EMPLOYEE_LEVELS_LIST_FAILURE = 'EMPLOYEE_LEVELS_LIST_FAILURE'
export const EMPLOYEE_LEVELS_LIST_RESET = 'EMPLOYEE_LEVELS_LIST_RESET'

export const EMPLOYEE_LEVELS_EDIT_REQUEST = 'EMPLOYEE_LEVELS_EDIT_REQUEST'
export const EMPLOYEE_LEVELS_EDIT_SUCCESS = 'EMPLOYEE_LEVELS_EDIT_SUCCESS'
export const EMPLOYEE_LEVELS_EDIT_FAILURE = 'EMPLOYEE_LEVELS_EDIT_FAILURE'
export const EMPLOYEE_LEVELS_EDIT_RESET = 'EMPLOYEE_LEVELS_EDIT_RESET'

export const EMPLOYEE_LEVELS_DEACTIVATE_REQUEST = 'EMPLOYEE_LEVELS_DEACTIVATE_REQUEST'
export const EMPLOYEE_LEVELS_DEACTIVATE_SUCCESS = 'EMPLOYEE_LEVELS_DEACTIVATE_SUCCESS'
export const EMPLOYEE_LEVELS_DEACTIVATE_FAILURE = 'EMPLOYEE_LEVELS_DEACTIVATE_FAILURE'
export const EMPLOYEE_LEVELS_DEACTIVATE_RESET = 'EMPLOYEE_LEVELS_DEACTIVATE_RESET'

export const EMPLOYEE_LEVELS_CREATE_REQUEST = 'EMPLOYEE_LEVELS_CREATE_REQUEST'
export const EMPLOYEE_LEVELS_CREATE_SUCCESS = 'EMPLOYEE_LEVELS_CREATE_SUCCESS'
export const EMPLOYEE_LEVELS_CREATE_FAILURE = 'EMPLOYEE_LEVELS_CREATE_FAILURE'
export const EMPLOYEE_LEVELS_CREATE_RESET = 'EMPLOYEE_LEVELS_CREATE_RESET'

export const EMPLOYEE_LEVELS_EXPORT_REQUEST = 'EMPLOYEE_LEVELS_EXPORT_REQUEST'
export const EMPLOYEE_LEVELS_EXPORT_SUCCESS = 'EMPLOYEE_LEVELS_EXPORT_SUCCESS'
export const EMPLOYEE_LEVELS_EXPORT_FAILURE = 'EMPLOYEE_LEVELS_EXPORT_FAILURE'
export const EMPLOYEE_LEVELS_EXPORT_RESET = 'EMPLOYEE_LEVELS_EXPORT_RESET'

export const DEPARTMENT_GET_REQUEST = 'DEPARTMENT_GET_REQUEST'
export const DEPARTMENT_GET_SUCCESS = 'DEPARTMENT_GET_SUCCESS'
export const DEPARTMENT_GET_FAILURE = 'DEPARTMENT_GET_FAILURE'
export const DEPARTMENT_GET_RESET = 'DEPARTMENT_GET_RESET'

export const DEPARTMENT_LIST_REQUEST = 'DEPARTMENT_LIST_REQUEST'
export const DEPARTMENT_LIST_SUCCESS = 'DEPARTMENT_LIST_SUCCESS'
export const DEPARTMENT_LIST_FAILURE = 'DEPARTMENT_LIST_FAILURE'
export const DEPARTMENT_LIST_RESET = 'DEPARTMENT_LIST_RESET'

export const DEPARTMENT_EDIT_REQUEST = 'DEPARTMENT_EDIT_REQUEST'
export const DEPARTMENT_EDIT_SUCCESS = 'DEPARTMENT_EDIT_SUCCESS'
export const DEPARTMENT_EDIT_FAILURE = 'DEPARTMENT_EDIT_FAILURE'
export const DEPARTMENT_EDIT_RESET = 'DEPARTMENT_EDIT_RESET'

export const DEPARTMENT_DEACTIVATE_REQUEST = 'DEPARTMENT_DEACTIVATE_REQUEST'
export const DEPARTMENT_DEACTIVATE_SUCCESS = 'DEPARTMENT_DEACTIVATE_SUCCESS'
export const DEPARTMENT_DEACTIVATE_FAILURE = 'DEPARTMENT_DEACTIVATE_FAILURE'
export const DEPARTMENT_DEACTIVATE_RESET = 'DEPARTMENT_DEACTIVATE_RESET'

export const DEPARTMENT_CREATE_REQUEST = 'DEPARTMENT_CREATE_REQUEST'
export const DEPARTMENT_CREATE_SUCCESS = 'DEPARTMENT_CREATE_SUCCESS'
export const DEPARTMENT_CREATE_FAILURE = 'DEPARTMENT_CREATE_FAILURE'
export const DEPARTMENT_CREATE_RESET = 'DEPARTMENT_CREATE_RESET'

export const DEPARTMENT_EXPORT_REQUEST = 'DEPARTMENT_EXPORT_REQUEST'
export const DEPARTMENT_EXPORT_SUCCESS = 'DEPARTMENT_EXPORT_SUCCESS'
export const DEPARTMENT_EXPORT_FAILURE = 'DEPARTMENT_EXPORT_FAILURE'
export const DEPARTMENT_EXPORT_RESET = 'DEPARTMENT_EXPORT_RESET'

export const DIVISION_GET_REQUEST = 'DIVISION_GET_REQUEST'
export const DIVISION_GET_SUCCESS = 'DIVISION_GET_SUCCESS'
export const DIVISION_GET_FAILURE = 'DIVISION_GET_FAILURE'
export const DIVISION_GET_RESET = 'DIVISION_GET_RESET'

export const DIVISION_LIST_REQUEST = 'DIVISION_LIST_REQUEST'
export const DIVISION_LIST_SUCCESS = 'DIVISION_LIST_SUCCESS'
export const DIVISION_LIST_FAILURE = 'DIVISION_LIST_FAILURE'
export const DIVISION_LIST_RESET = 'DIVISION_LIST_RESET'

export const DIVISION_EDIT_REQUEST = 'DIVISION_EDIT_REQUEST'
export const DIVISION_EDIT_SUCCESS = 'DIVISION_EDIT_SUCCESS'
export const DIVISION_EDIT_FAILURE = 'DIVISION_EDIT_FAILURE'
export const DIVISION_EDIT_RESET = 'DIVISION_EDIT_RESET'

export const DIVISION_DEACTIVATE_REQUEST = 'DIVISION_DEACTIVATE_REQUEST'
export const DIVISION_DEACTIVATE_SUCCESS = 'DIVISION_DEACTIVATE_SUCCESS'
export const DIVISION_DEACTIVATE_FAILURE = 'DIVISION_DEACTIVATE_FAILURE'
export const DIVISION_DEACTIVATE_RESET = 'DIVISION_DEACTIVATE_RESET'

export const DIVISION_CREATE_REQUEST = 'DIVISION_CREATE_REQUEST'
export const DIVISION_CREATE_SUCCESS = 'DIVISION_CREATE_SUCCESS'
export const DIVISION_CREATE_FAILURE = 'DIVISION_CREATE_FAILURE'
export const DIVISION_CREATE_RESET = 'DIVISION_CREATE_RESET'

export const DIVISION_EXPORT_REQUEST = 'DIVISION_EXPORT_REQUEST'
export const DIVISION_EXPORT_SUCCESS = 'DIVISION_EXPORT_SUCCESS'
export const DIVISION_EXPORT_FAILURE = 'DIVISION_EXPORT_FAILURE'
export const DIVISION_EXPORT_RESET = 'DIVISION_EXPORT_RESET'

export const POSITION_GET_REQUEST = 'POSITION_GET_REQUEST'
export const POSITION_GET_SUCCESS = 'POSITION_GET_SUCCESS'
export const POSITION_GET_FAILURE = 'POSITION_GET_FAILURE'
export const POSITION_GET_RESET = 'POSITION_GET_RESET'

export const POSITION_LIST_REQUEST = 'POSITION_LIST_REQUEST'
export const POSITION_LIST_SUCCESS = 'POSITION_LIST_SUCCESS'
export const POSITION_LIST_FAILURE = 'POSITION_LIST_FAILURE'
export const POSITION_LIST_RESET = 'POSITION_LIST_RESET'

export const POSITION_DEACTIVATE_REQUEST = 'POSITION_DEACTIVATE_REQUEST'
export const POSITION_DEACTIVATE_SUCCESS = 'POSITION_DEACTIVATE_SUCCESS'
export const POSITION_DEACTIVATE_FAILURE = 'POSITION_DEACTIVATE_FAILURE'
export const POSITION_DEACTIVATE_RESET = 'POSITION_DEACTIVATE_RESET'

export const POSITION_EDIT_REQUEST = 'POSITION_EDIT_REQUEST'
export const POSITION_EDIT_SUCCESS = 'POSITION_EDIT_SUCCESS'
export const POSITION_EDIT_FAILURE = 'POSITION_EDIT_FAILURE'
export const POSITION_EDIT_RESET = 'POSITION_EDIT_RESET'

export const POSITION_CREATE_REQUEST = 'POSITION_CREATE_REQUEST'
export const POSITION_CREATE_SUCCESS = 'POSITION_CREATE_SUCCESS'
export const POSITION_CREATE_FAILURE = 'POSITION_CREATE_FAILURE'
export const POSITION_CREATE_RESET = 'POSITION_CREATE_RESET'

export const POSITION_EXPORT_REQUEST = 'POSITION_EXPORT_REQUEST'
export const POSITION_EXPORT_SUCCESS = 'POSITION_EXPORT_SUCCESS'
export const POSITION_EXPORT_FAILURE = 'POSITION_EXPORT_FAILURE'
export const POSITION_EXPORT_RESET = 'POSITION_EXPORT_RESET'

export const POSITION_IMPORT_REQUEST = 'POSITION_IMPORT_REQUEST'
export const POSITION_IMPORT_SUCCESS = 'POSITION_IMPORT_SUCCESS'
export const POSITION_IMPORT_FAILURE = 'POSITION_IMPORT_FAILURE'
export const POSITION_IMPORT_RESET = 'POSITION_IMPORT_RESET'

export const TEAM_GET_REQUEST = 'TEAM_GET_REQUEST'
export const TEAM_GET_SUCCESS = 'TEAM_GET_SUCCESS'
export const TEAM_GET_FAILURE = 'TEAM_GET_FAILURE'
export const TEAM_GET_RESET = 'TEAM_GET_RESET'

export const TEAM_LIST_REQUEST = 'TEAM_LIST_REQUEST'
export const TEAM_LIST_SUCCESS = 'TEAM_LIST_SUCCESS'
export const TEAM_LIST_FAILURE = 'TEAM_LIST_FAILURE'
export const TEAM_LIST_RESET = 'TEAM_LIST_RESET'

export const TEAM_DEACTIVATE_REQUEST = 'TEAM_DEACTIVATE_REQUEST'
export const TEAM_DEACTIVATE_SUCCESS = 'TEAM_DEACTIVATE_SUCCESS'
export const TEAM_DEACTIVATE_FAILURE = 'TEAM_DEACTIVATE_FAILURE'
export const TEAM_DEACTIVATE_RESET = 'TEAM_DEACTIVATE_RESET'

export const TEAM_EDIT_REQUEST = 'TEAM_EDIT_REQUEST'
export const TEAM_EDIT_SUCCESS = 'TEAM_EDIT_SUCCESS'
export const TEAM_EDIT_FAILURE = 'TEAM_EDIT_FAILURE'
export const TEAM_EDIT_RESET = 'TEAM_EDIT_RESET'

export const TEAM_CREATE_REQUEST = 'TEAM_CREATE_REQUEST'
export const TEAM_CREATE_SUCCESS = 'TEAM_CREATE_SUCCESS'
export const TEAM_CREATE_FAILURE = 'TEAM_CREATE_FAILURE'
export const TEAM_CREATE_RESET = 'TEAM_CREATE_RESET'

export const TEAM_EXPORT_REQUEST = 'TEAM_EXPORT_REQUEST'
export const TEAM_EXPORT_SUCCESS = 'TEAM_EXPORT_SUCCESS'
export const TEAM_EXPORT_FAILURE = 'TEAM_EXPORT_FAILURE'
export const TEAM_EXPORT_RESET = 'TEAM_EXPORT_RESET'

export const COMPANY_GET_REQUEST = 'COMPANY_GET_REQUEST'
export const COMPANY_GET_SUCCESS = 'COMPANY_GET_SUCCESS'
export const COMPANY_GET_FAILURE = 'COMPANY_GET_FAILURE'
export const COMPANY_GET_RESET = 'COMPANY_GET_RESET'

export const COMPANY_LIST_REQUEST = 'COMPANY_LIST_REQUEST'
export const COMPANY_LIST_SUCCESS = 'COMPANY_LIST_SUCCESS'
export const COMPANY_LIST_FAILURE = 'COMPANY_LIST_FAILURE'
export const COMPANY_LIST_RESET = 'COMPANY_LIST_RESET'

export const COMPANY_DEACTIVATE_REQUEST = 'COMPANY_DEACTIVATE_REQUEST'
export const COMPANY_DEACTIVATE_SUCCESS = 'COMPANY_DEACTIVATE_SUCCESS'
export const COMPANY_DEACTIVATE_FAILURE = 'COMPANY_DEACTIVATE_FAILURE'
export const COMPANY_DEACTIVATE_RESET = 'COMPANY_DEACTIVATE_RESET'

export const COMPANY_EDIT_REQUEST = 'COMPANY_EDIT_REQUEST'
export const COMPANY_EDIT_SUCCESS = 'COMPANY_EDIT_SUCCESS'
export const COMPANY_EDIT_FAILURE = 'COMPANY_EDIT_FAILURE'
export const COMPANY_EDIT_RESET = 'COMPANY_EDIT_RESET'

export const COMPANY_CREATE_REQUEST = 'COMPANY_CREATE_REQUEST'
export const COMPANY_CREATE_SUCCESS = 'COMPANY_CREATE_SUCCESS'
export const COMPANY_CREATE_FAILURE = 'COMPANY_CREATE_FAILURE'
export const COMPANY_CREATE_RESET = 'COMPANY_CREATE_RESET'

export const COMPANY_EXPORT_REQUEST = 'COMPANY_EXPORT_REQUEST'
export const COMPANY_EXPORT_SUCCESS = 'COMPANY_EXPORT_SUCCESS'
export const COMPANY_EXPORT_FAILURE = 'COMPANY_EXPORT_FAILURE'
export const COMPANY_EXPORT_RESET = 'COMPANY_EXPORT_RESET'

export const CONFIDENTIAL_GET_REQUEST = 'CONFIDENTIAL_GET_REQUEST'
export const CONFIDENTIAL_GET_SUCCESS = 'CONFIDENTIAL_GET_SUCCESS'
export const CONFIDENTIAL_GET_FAILURE = 'CONFIDENTIAL_GET_FAILURE'
export const CONFIDENTIAL_GET_RESET = 'CONFIDENTIAL_GET_RESET'

export const CONFIDENTIAL_LIST_REQUEST = 'CONFIDENTIAL_LIST_REQUEST'
export const CONFIDENTIAL_LIST_SUCCESS = 'CONFIDENTIAL_LIST_SUCCESS'
export const CONFIDENTIAL_LIST_FAILURE = 'CONFIDENTIAL_LIST_FAILURE'
export const CONFIDENTIAL_LIST_RESET = 'CONFIDENTIAL_LIST_RESET'

export const CONFIDENTIAL_CREATE_REQUEST = 'CONFIDENTIAL_CREATE_REQUEST'
export const CONFIDENTIAL_CREATE_SUCCESS = 'CONFIDENTIAL_CREATE_SUCCESS'
export const CONFIDENTIAL_CREATE_FAILURE = 'CONFIDENTIAL_CREATE_FAILURE'
export const CONFIDENTIAL_CREATE_RESET = 'CONFIDENTIAL_CREATE_RESET'

export const CONFIDENTIAL_EDIT_REQUEST = 'CONFIDENTIAL_EDIT_REQUEST'
export const CONFIDENTIAL_EDIT_SUCCESS = 'CONFIDENTIAL_EDIT_SUCCESS'
export const CONFIDENTIAL_EDIT_FAILURE = 'CONFIDENTIAL_EDIT_FAILURE'
export const CONFIDENTIAL_EDIT_RESET = 'CONFIDENTIAL_EDIT_RESET'

export const CONFIDENTIAL_DEACTIVATE_REQUEST = 'CONFIDENTIAL_DEACTIVATE_REQUEST'
export const CONFIDENTIAL_DEACTIVATE_SUCCESS = 'CONFIDENTIAL_DEACTIVATE_SUCCESS'
export const CONFIDENTIAL_DEACTIVATE_FAILURE = 'CONFIDENTIAL_DEACTIVATE_FAILURE'
export const CONFIDENTIAL_DEACTIVATE_RESET = 'CONFIDENTIAL_DEACTIVATE_RESET'

export const CONFIDENTIAL_IMPORT_REQUEST = 'CONFIDENTIAL_IMPORT_REQUEST'
export const CONFIDENTIAL_IMPORT_SUCCESS = 'CONFIDENTIAL_IMPORT_SUCCESS'
export const CONFIDENTIAL_IMPORT_FAILURE = 'CONFIDENTIAL_IMPORT_FAILURE'
export const CONFIDENTIAL_IMPORT_RESET = 'CONFIDENTIAL_IMPORT_RESET'

export const CONFIDENTIAL_EXPORT_REQUEST = 'CONFIDENTIAL_EXPORT_REQUEST'
export const CONFIDENTIAL_EXPORT_SUCCESS = 'CONFIDENTIAL_EXPORT_SUCCESS'
export const CONFIDENTIAL_EXPORT_FAILURE = 'CONFIDENTIAL_EXPORT_FAILURE'
export const CONFIDENTIAL_EXPORT_RESET = 'CONFIDENTIAL_EXPORT_RESET'

export const STANDARD_PRICE_CREATE_REQUEST = 'STANDARD_PRICE_CREATE_REQUEST'
export const STANDARD_PRICE_CREATE_SUCCESS = 'STANDARD_PRICE_CREATE_SUCCESS'
export const STANDARD_PRICE_CREATE_FAILURE = 'STANDARD_PRICE_CREATE_FAILURE'
export const STANDARD_PRICE_CREATE_RESET = 'STANDARD_PRICE_CREATE_RESET'

export const STANDARD_PRICE_GET_REQUEST = 'STANDARD_PRICE_GET_REQUEST'
export const STANDARD_PRICE_GET_SUCCESS = 'STANDARD_PRICE_GET_SUCCESS'
export const STANDARD_PRICE_GET_FAILURE = 'STANDARD_PRICE_GET_FAILURE'
export const STANDARD_PRICE_GET_RESET = 'STANDARD_PRICE_GET_RESET'

export const STANDARD_PRICE_EDIT_REQUEST = 'STANDARD_PRICE_EDIT_REQUEST'
export const STANDARD_PRICE_EDIT_SUCCESS = 'STANDARD_PRICE_EDIT_SUCCESS'
export const STANDARD_PRICE_EDIT_FAILURE = 'STANDARD_PRICE_EDIT_FAILURE'
export const STANDARD_PRICE_EDIT_RESET = 'STANDARD_PRICE_EDIT_RESET'

export const STANDARD_PRICE_LIST_REQUEST = 'STANDARD_PRICE_LIST_REQUEST'
export const STANDARD_PRICE_LIST_SUCCESS = 'STANDARD_PRICE_LIST_SUCCESS'
export const STANDARD_PRICE_LIST_FAILURE = 'STANDARD_PRICE_LIST_FAILURE'
export const STANDARD_PRICE_LIST_RESET = 'STANDARD_PRICE_LIST_RESET'

export const STANDARD_PRICE_DEACTIVATE_REQUEST = 'STANDARD_PRICE_DEACTIVATE_REQUEST'
export const STANDARD_PRICE_DEACTIVATE_SUCCESS = 'STANDARD_PRICE_DEACTIVATE_SUCCESS'
export const STANDARD_PRICE_DEACTIVATE_FAILURE = 'STANDARD_PRICE_DEACTIVATE_FAILURE'
export const STANDARD_PRICE_DEACTIVATE_RESET = 'STANDARD_PRICE_DEACTIVATE_RESET'

export const STANDARD_PRICE_EXPORT_REQUEST = 'STANDARD_PRICE_EXPORT_REQUEST'
export const STANDARD_PRICE_EXPORT_SUCCESS = 'STANDARD_PRICE_EXPORT_SUCCESS'
export const STANDARD_PRICE_EXPORT_FAILURE = 'STANDARD_PRICE_EXPORT_FAILURE'
export const STANDARD_PRICE_EXPORT_RESET = 'STANDARD_PRICE_EXPORT_RESET'

export const LEAVE_REQUEST_GET_REQUEST = 'LEAVE_REQUEST_GET_REQUEST'
export const LEAVE_REQUEST_GET_SUCCESS = 'LEAVE_REQUEST_GET_SUCCESS'
export const LEAVE_REQUEST_GET_FAILURE = 'LEAVE_REQUEST_GET_FAILURE'
export const LEAVE_REQUEST_GET_RESET = 'LEAVE_REQUEST_GET_RESET'

export const LEAVE_REQUEST_CREATE_REQUEST = 'LEAVE_REQUEST_CREATE_REQUEST'
export const LEAVE_REQUEST_CREATE_SUCCESS = 'LEAVE_REQUEST_CREATE_SUCCESS'
export const LEAVE_REQUEST_CREATE_FAILURE = 'LEAVE_REQUEST_CREATE_FAILURE'
export const LEAVE_REQUEST_CREATE_RESET = 'LEAVE_REQUEST_CREATE_RESET'

export const LEAVE_REQUEST_PREVIEW_REQUEST = 'LEAVE_REQUEST_PREVIEW_REQUEST'
export const LEAVE_REQUEST_PREVIEW_SUCCESS = 'LEAVE_REQUEST_PREVIEW_SUCCESS'
export const LEAVE_REQUEST_PREVIEW_FAILURE = 'LEAVE_REQUEST_PREVIEW_FAILURE'
export const LEAVE_REQUEST_PREVIEW_RESET = 'LEAVE_REQUEST_PREVIEW_RESET'

export const LEAVE_REQUEST_APPROVE_REQUEST = 'LEAVE_REQUEST_APPROVE_REQUEST'
export const LEAVE_REQUEST_APPROVE_SUCCESS = 'LEAVE_REQUEST_APPROVE_SUCCESS'
export const LEAVE_REQUEST_APPROVE_FAILURE = 'LEAVE_REQUEST_APPROVE_FAILURE'
export const LEAVE_REQUEST_APPROVE_RESET = 'LEAVE_REQUEST_APPROVE_RESET'

export const LEAVE_REQUEST_CANCEL_REQUEST = 'LEAVE_REQUEST_CANCEL_REQUEST'
export const LEAVE_REQUEST_CANCEL_SUCCESS = 'LEAVE_REQUEST_CANCEL_SUCCESS'
export const LEAVE_REQUEST_CANCEL_FAILURE = 'LEAVE_REQUEST_CANCEL_FAILURE'
export const LEAVE_REQUEST_CANCEL_RESET = 'LEAVE_REQUEST_CANCEL_RESET'

export const PUBLIC_HOLIDAY_CALENDARS_REQUEST = 'PUBLIC_HOLIDAY_CALENDARS_REQUEST'
export const PUBLIC_HOLIDAY_CALENDARS_SUCCESS = 'PUBLIC_HOLIDAY_CALENDARS_SUCCESS'
export const PUBLIC_HOLIDAY_CALENDARS_FAILURE = 'PUBLIC_HOLIDAY_CALENDARS_FAILURE'
export const PUBLIC_HOLIDAY_CALENDARS_RESET = 'PUBLIC_HOLIDAY_CALENDARS_RESET'

export const PUBLIC_HOLIDAY_LIST_REQUEST = 'PUBLIC_HOLIDAY_LIST_REQUEST'
export const PUBLIC_HOLIDAY_LIST_SUCCESS = 'PUBLIC_HOLIDAY_LIST_SUCCESS'
export const PUBLIC_HOLIDAY_LIST_FAILURE = 'PUBLIC_HOLIDAY_LIST_FAILURE'
export const PUBLIC_HOLIDAY_LIST_RESET = 'PUBLIC_HOLIDAY_LIST_RESET'

export const PUBLIC_HOLIDAY_CREATE_REQUEST = 'PUBLIC_HOLIDAY_CREATE_REQUEST'
export const PUBLIC_HOLIDAY_CREATE_SUCCESS = 'PUBLIC_HOLIDAY_CREATE_SUCCESS'
export const PUBLIC_HOLIDAY_CREATE_FAILURE = 'PUBLIC_HOLIDAY_CREATE_FAILURE'
export const PUBLIC_HOLIDAY_CREATE_RESET = 'PUBLIC_HOLIDAY_CREATE_RESET'

export const PUBLIC_HOLIDAY_GET_REQUEST = 'PUBLIC_HOLIDAY_GET_REQUEST'
export const PUBLIC_HOLIDAY_GET_SUCCESS = 'PUBLIC_HOLIDAY_GET_SUCCESS'
export const PUBLIC_HOLIDAY_GET_FAILURE = 'PUBLIC_HOLIDAY_GET_FAILURE'
export const PUBLIC_HOLIDAY_GET_RESET = 'PUBLIC_HOLIDAY_GET_RESET'

export const PUBLIC_HOLIDAY_EDIT_REQUEST = 'PUBLIC_HOLIDAY_EDIT_REQUEST'
export const PUBLIC_HOLIDAY_EDIT_SUCCESS = 'PUBLIC_HOLIDAY_EDIT_SUCCESS'
export const PUBLIC_HOLIDAY_EDIT_FAILURE = 'PUBLIC_HOLIDAY_EDIT_FAILURE'
export const PUBLIC_HOLIDAY_EDIT_RESET = 'PUBLIC_HOLIDAY_EDIT_RESET'

export const PUBLIC_HOLIDAY_DELETE_REQUEST = 'PUBLIC_HOLIDAY_DELETE_REQUEST'
export const PUBLIC_HOLIDAY_DELETE_SUCCESS = 'PUBLIC_HOLIDAY_DELETE_SUCCESS'
export const PUBLIC_HOLIDAY_DELETE_FAILURE = 'PUBLIC_HOLIDAY_DELETE_FAILURE'
export const PUBLIC_HOLIDAY_DELETE_RESET = 'PUBLIC_HOLIDAY_DELETE_RESET'

export const PUBLIC_HOLIDAY_EXPORT_REQUEST = 'PUBLIC_HOLIDAY_EXPORT_REQUEST'
export const PUBLIC_HOLIDAY_EXPORT_SUCCESS = 'PUBLIC_HOLIDAY_EXPORT_SUCCESS'
export const PUBLIC_HOLIDAY_EXPORT_FAILURE = 'PUBLIC_HOLIDAY_EXPORT_FAILURE'
export const PUBLIC_HOLIDAY_EXPORT_RESET = 'PUBLIC_HOLIDAY_EXPORT_RESET'

export const LEAVE_ENTITLEMENT_LIST_REQUEST = 'LEAVE_ENTITLEMENT_LIST_REQUEST'
export const LEAVE_ENTITLEMENT_LIST_SUCCESS = 'LEAVE_ENTITLEMENT_LIST_SUCCESS'
export const LEAVE_ENTITLEMENT_LIST_FAILURE = 'LEAVE_ENTITLEMENT_LIST_FAILURE'
export const LEAVE_ENTITLEMENT_LIST_RESET = 'LEAVE_ENTITLEMENT_LIST_RESET'

export const LEAVE_ENTITLEMENT_CREATE_REQUEST = 'LEAVE_ENTITLEMENT_CREATE_REQUEST'
export const LEAVE_ENTITLEMENT_CREATE_SUCCESS = 'LEAVE_ENTITLEMENT_CREATE_SUCCESS'
export const LEAVE_ENTITLEMENT_CREATE_FAILURE = 'LEAVE_ENTITLEMENT_CREATE_FAILURE'
export const LEAVE_ENTITLEMENT_CREATE_RESET = 'LEAVE_ENTITLEMENT_CREATE_RESET'

export const LEAVE_ENTITLEMENT_GET_REQUEST = 'LEAVE_ENTITLEMENT_GET_REQUEST'
export const LEAVE_ENTITLEMENT_GET_SUCCESS = 'LEAVE_ENTITLEMENT_GET_SUCCESS'
export const LEAVE_ENTITLEMENT_GET_FAILURE = 'LEAVE_ENTITLEMENT_GET_FAILURE'
export const LEAVE_ENTITLEMENT_GET_RESET = 'LEAVE_ENTITLEMENT_GET_RESET'

export const LEAVE_ENTITLEMENT_EDIT_REQUEST = 'LEAVE_ENTITLEMENT_EDIT_REQUEST'
export const LEAVE_ENTITLEMENT_EDIT_SUCCESS = 'LEAVE_ENTITLEMENT_EDIT_SUCCESS'
export const LEAVE_ENTITLEMENT_EDIT_FAILURE = 'LEAVE_ENTITLEMENT_EDIT_FAILURE'
export const LEAVE_ENTITLEMENT_EDIT_RESET = 'LEAVE_ENTITLEMENT_EDIT_RESET'

export const LEAVE_ENTITLEMENT_DELETE_REQUEST = 'LEAVE_ENTITLEMENT_DELETE_REQUEST'
export const LEAVE_ENTITLEMENT_DELETE_SUCCESS = 'LEAVE_ENTITLEMENT_DELETE_SUCCESS'
export const LEAVE_ENTITLEMENT_DELETE_FAILURE = 'LEAVE_ENTITLEMENT_DELETE_FAILURE'
export const LEAVE_ENTITLEMENT_DELETE_RESET = 'LEAVE_ENTITLEMENT_DELETE_RESET'

export const LEAVE_ENTITLEMENT_EXPORT_REQUEST = 'LEAVE_ENTITLEMENT_EXPORT_REQUEST'
export const LEAVE_ENTITLEMENT_EXPORT_SUCCESS = 'LEAVE_ENTITLEMENT_EXPORT_SUCCESS'
export const LEAVE_ENTITLEMENT_EXPORT_FAILURE = 'LEAVE_ENTITLEMENT_EXPORT_FAILURE'
export const LEAVE_ENTITLEMENT_EXPORT_RESET = 'LEAVE_ENTITLEMENT_EXPORT_RESET'

export const LEAVE_TYPE_LIST_REQUEST = 'LEAVE_TYPE_LIST_REQUEST'
export const LEAVE_TYPE_LIST_SUCCESS = 'LEAVE_TYPE_LIST_SUCCESS'
export const LEAVE_TYPE_LIST_FAILURE = 'LEAVE_TYPE_LIST_FAILURE'
export const LEAVE_TYPE_LIST_RESET = 'LEAVE_TYPE_LIST_RESET'

export const LEAVE_TYPE_CREATE_REQUEST = 'LEAVE_TYPE_CREATE_REQUEST'
export const LEAVE_TYPE_CREATE_SUCCESS = 'LEAVE_TYPE_CREATE_SUCCESS'
export const LEAVE_TYPE_CREATE_FAILURE = 'LEAVE_TYPE_CREATE_FAILURE'
export const LEAVE_TYPE_CREATE_RESET = 'LEAVE_TYPE_CREATE_RESET'

export const LEAVE_TYPE_GET_REQUEST = 'LEAVE_TYPE_GET_REQUEST'
export const LEAVE_TYPE_GET_SUCCESS = 'LEAVE_TYPE_GET_SUCCESS'
export const LEAVE_TYPE_GET_FAILURE = 'LEAVE_TYPE_GET_FAILURE'
export const LEAVE_TYPE_GET_RESET = 'LEAVE_TYPE_GET_RESET'

export const LEAVE_TYPE_EDIT_REQUEST = 'LEAVE_TYPE_EDIT_REQUEST'
export const LEAVE_TYPE_EDIT_SUCCESS = 'LEAVE_TYPE_EDIT_SUCCESS'
export const LEAVE_TYPE_EDIT_FAILURE = 'LEAVE_TYPE_EDIT_FAILURE'
export const LEAVE_TYPE_EDIT_RESET = 'LEAVE_TYPE_EDIT_RESET'

export const LEAVE_TYPE_DELETE_REQUEST = 'LEAVE_TYPE_DELETE_REQUEST'
export const LEAVE_TYPE_DELETE_SUCCESS = 'LEAVE_TYPE_DELETE_SUCCESS'
export const LEAVE_TYPE_DELETE_FAILURE = 'LEAVE_TYPE_DELETE_FAILURE'
export const LEAVE_TYPE_DELETE_RESET = 'LEAVE_TYPE_DELETE_RESET'

export const LEAVE_TYPE_EXPORT_REQUEST = 'LEAVE_TYPE_EXPORT_REQUEST'
export const LEAVE_TYPE_EXPORT_SUCCESS = 'LEAVE_TYPE_EXPORT_SUCCESS'
export const LEAVE_TYPE_EXPORT_FAILURE = 'LEAVE_TYPE_EXPORT_FAILURE'
export const LEAVE_TYPE_EXPORT_RESET = 'LEAVE_TYPE_EXPORT_RESET'

export const LEAVE_GENERTION_GET_REQUEST = 'LEAVE_GENERTION_GET_REQUEST'
export const LEAVE_GENERTION_GET_SUCCESS = 'LEAVE_GENERTION_GET_SUCCESS'
export const LEAVE_GENERTION_GET_FAILURE = 'LEAVE_GENERTION_GET_FAILURE'
export const LEAVE_GENERTION_GET_RESET = 'LEAVE_GENERTION_GET_RESET'

export const LEAVE_GENERTION_EDIT_REQUEST = 'LEAVE_GENERTION_EDIT_REQUEST'
export const LEAVE_GENERTION_EDIT_SUCCESS = 'LEAVE_GENERTION_EDIT_SUCCESS'
export const LEAVE_GENERTION_EDIT_FAILURE = 'LEAVE_GENERTION_EDIT_FAILURE'
export const LEAVE_GENERTION_EDIT_RESET = 'LEAVE_GENERTION_EDIT_RESET'

export const LEAVE_GENERTION_IMPORT_REQUEST = 'LEAVE_GENERTION_IMPORT_REQUEST'
export const LEAVE_GENERTION_IMPORT_SUCCESS = 'LEAVE_GENERTION_IMPORT_SUCCESS'
export const LEAVE_GENERTION_IMPORT_FAILURE = 'LEAVE_GENERTION_IMPORT_FAILURE'
export const LEAVE_GENERTION_IMPORT_RESET = 'LEAVE_GENERTION_IMPORT_RESET'

export const LEAVE_GENERTION_EXPORT_REQUEST = 'LEAVE_GENERTION_EXPORT_REQUEST'
export const LEAVE_GENERTION_EXPORT_SUCCESS = 'LEAVE_GENERTION_EXPORT_SUCCESS'
export const LEAVE_GENERTION_EXPORT_FAILURE = 'LEAVE_GENERTION_EXPORT_FAILURE'
export const LEAVE_GENERTION_EXPORT_RESET = 'LEAVE_GENERTION_EXPORT_RESET'

export const LEAVE_GENERTION_USER_EXPORT_REQUEST = 'LEAVE_GENERTION_USER_EXPORT_REQUEST'
export const LEAVE_GENERTION_USER_EXPORT_SUCCESS = 'LEAVE_GENERTION_USER_EXPORT_SUCCESS'
export const LEAVE_GENERTION_USER_EXPORT_FAILURE = 'LEAVE_GENERTION_USER_EXPORT_FAILURE'
export const LEAVE_GENERTION_USER_EXPORT_RESET = 'LEAVE_GENERTION_USER_EXPORT_RESET'

export const REPORT_HEADCOUNT_GET_REQUEST = 'REPORT_HEADCOUNT_GET_REQUEST'
export const REPORT_HEADCOUNT_GET_SUCCESS = 'REPORT_HEADCOUNT_GET_SUCCESS'
export const REPORT_HEADCOUNT_GET_FAILURE = 'REPORT_HEADCOUNT_GET_FAILURE'
export const REPORT_HEADCOUNT_GET_RESET = 'REPORT_HEADCOUNT_GET_RESET'

export const REPORT_HEADCOUNT_EXPORT_REQUEST = 'REPORT_HEADCOUNT_EXPORT_REQUEST'
export const REPORT_HEADCOUNT_EXPORT_SUCCESS = 'REPORT_HEADCOUNT_EXPORT_SUCCESS'
export const REPORT_HEADCOUNT_EXPORT_FAILURE = 'REPORT_HEADCOUNT_EXPORT_FAILURE'
export const REPORT_HEADCOUNT_EXPORT_RESET = 'REPORT_HEADCOUNT_EXPORT_RESET'

export const REPORT_YEAR_OF_SERVICE_GET_REQUEST = 'REPORT_YEAR_OF_SERVICE_GET_REQUEST'
export const REPORT_YEAR_OF_SERVICE_GET_SUCCESS = 'REPORT_YEAR_OF_SERVICE_GET_SUCCESS'
export const REPORT_YEAR_OF_SERVICE_GET_FAILURE = 'REPORT_YEAR_OF_SERVICE_GET_FAILURE'
export const REPORT_YEAR_OF_SERVICE_GET_RESET = 'REPORT_YEAR_OF_SERVICE_GET_RESET'

export const REPORT_YEAR_OF_SERVICE_EXPORT_REQUEST = 'REPORT_YEAR_OF_SERVICE_EXPORT_REQUEST'
export const REPORT_YEAR_OF_SERVICE_EXPORT_SUCCESS = 'REPORT_YEAR_OF_SERVICE_EXPORT_SUCCESS'
export const REPORT_YEAR_OF_SERVICE_EXPORT_FAILURE = 'REPORT_YEAR_OF_SERVICE_EXPORT_FAILURE'
export const REPORT_YEAR_OF_SERVICE_EXPORT_RESET = 'REPORT_YEAR_OF_SERVICE_EXPORT_RESET'

export const REPORT_LEAVE_HISTORY_GET_REQUEST = 'REPORT_LEAVE_HISTORY_GET_REQUEST'
export const REPORT_LEAVE_HISTORY_GET_SUCCESS = 'REPORT_LEAVE_HISTORY_GET_SUCCESS'
export const REPORT_LEAVE_HISTORY_GET_FAILURE = 'REPORT_LEAVE_HISTORY_GET_FAILURE'
export const REPORT_LEAVE_HISTORY_GET_RESET = 'REPORT_LEAVE_HISTORY_GET_RESET'

export const REPORT_LEAVE_HISTORY_EXPORT_REQUEST = 'REPORT_LEAVE_HISTORY_EXPORT_REQUEST'
export const REPORT_LEAVE_HISTORY_EXPORT_SUCCESS = 'REPORT_LEAVE_HISTORY_EXPORT_SUCCESS'
export const REPORT_LEAVE_HISTORY_EXPORT_FAILURE = 'REPORT_LEAVE_HISTORY_EXPORT_FAILURE'
export const REPORT_LEAVE_HISTORY_EXPORT_RESET = 'REPORT_LEAVE_HISTORY_EXPORT_RESET'

export const REPORT_ACTIVE_USERS_GET_REQUEST = 'REPORT_ACTIVE_USERS_GET_REQUEST'
export const REPORT_ACTIVE_USERS_GET_SUCCESS = 'REPORT_ACTIVE_USERS_GET_SUCCESS'
export const REPORT_ACTIVE_USERS_GET_FAILURE = 'REPORT_ACTIVE_USERS_GET_FAILURE'
export const REPORT_ACTIVE_USERS_GET_RESET = 'REPORT_ACTIVE_USERS_GET_RESET'

export const REPORT_ACTIVE_USERS_EXPORT_REQUEST = 'REPORT_ACTIVE_USERS_EXPORT_REQUEST'
export const REPORT_ACTIVE_USERS_EXPORT_SUCCESS = 'REPORT_ACTIVE_USERS_EXPORT_SUCCESS'
export const REPORT_ACTIVE_USERS_EXPORT_FAILURE = 'REPORT_ACTIVE_USERS_EXPORT_FAILURE'
export const REPORT_ACTIVE_USERS_EXPORT_RESET = 'REPORT_ACTIVE_USERS_EXPORT_RESET'

export const REPORT_AUDIT_LOGS_EXPORT_REQUEST = 'REPORT_AUDIT_LOGS_EXPORT_REQUEST'
export const REPORT_AUDIT_LOGS_EXPORT_SUCCESS = 'REPORT_AUDIT_LOGS_EXPORT_SUCCESS'
export const REPORT_AUDIT_LOGS_EXPORT_FAILURE = 'REPORT_AUDIT_LOGS_EXPORT_FAILURE'
export const REPORT_AUDIT_LOGS_EXPORT_RESET = 'REPORT_AUDIT_LOGS_EXPORT_RESET'

export const REPORT_SUBCONTRACT_EXPORT_REQUEST = 'REPORT_SUBCONTRACT_EXPORT_REQUEST'
export const REPORT_SUBCONTRACT_EXPORT_SUCCESS = 'REPORT_SUBCONTRACT_EXPORT_SUCCESS'
export const REPORT_SUBCONTRACT_EXPORT_FAILURE = 'REPORT_SUBCONTRACT_EXPORT_FAILURE'
export const REPORT_SUBCONTRACT_EXPORT_RESET = 'REPORT_SUBCONTRACT_EXPORT_RESET'

export const REPORT_COMPENSATE_EXPORT_REQUEST = 'REPORT_COMPENSATE_EXPORT_REQUEST'
export const REPORT_COMPENSATE_EXPORT_SUCCESS = 'REPORT_COMPENSATE_EXPORT_SUCCESS'
export const REPORT_COMPENSATE_EXPORT_FAILURE = 'REPORT_COMPENSATE_EXPORT_FAILURE'
export const REPORT_COMPENSATE_EXPORT_RESET = 'REPORT_COMPENSATE_EXPORT_RESET'

export const REPORT_COMPENSATE_GET_REQUEST = 'REPORT_COMPENSATE_GET_REQUEST'
export const REPORT_COMPENSATE_GET_SUCCESS = 'REPORT_COMPENSATE_GET_SUCCESS'
export const REPORT_COMPENSATE_GET_FAILURE = 'REPORT_COMPENSATE_GET_FAILURE'
export const REPORT_COMPENSATE_GET_RESET = 'REPORT_COMPENSATE_GET_RESET'

export const REPORT_COMPENSATE_CANCEL_REQUEST = 'REPORT_COMPENSATE_CANCEL_REQUEST'
export const REPORT_COMPENSATE_CANCEL_SUCCESS = 'REPORT_COMPENSATE_CANCEL_SUCCESS'
export const REPORT_COMPENSATE_CANCEL_FAILURE = 'REPORT_COMPENSATE_CANCEL_FAILURE'
export const REPORT_COMPENSATE_CANCEL_RESET = 'REPORT_COMPENSATE_CANCEL_RESET'

export const REPORT_SUBCONTRACT_GET_REQUEST = 'REPORT_SUBCONTRACT_GET_REQUEST'
export const REPORT_SUBCONTRACT_GET_SUCCESS = 'REPORT_SUBCONTRACT_GET_SUCCESS'
export const REPORT_SUBCONTRACT_GET_FAILURE = 'REPORT_SUBCONTRACT_GET_FAILURE'
export const REPORT_SUBCONTRACT_GET_RESET = 'REPORT_SUBCONTRACT_GET_RESET'

export const REPORT_LEAVE_GENERATION_GET_REQUEST = 'REPORT_LEAVE_GENERATION_GET_REQUEST'
export const REPORT_LEAVE_GENERATION_GET_SUCCESS = 'REPORT_LEAVE_GENERATION_GET_SUCCESS'
export const REPORT_LEAVE_GENERATION_GET_FAILURE = 'REPORT_LEAVE_GENERATION_GET_FAILURE'
export const REPORT_LEAVE_GENERATION_GET_RESET = 'REPORT_LEAVE_GENERATION_GET_RESET'

export const PROJECT_INFORMATION_LIST_REQUEST = 'PROJECT_INFORMATION_LIST_REQUEST'
export const PROJECT_INFORMATION_LIST_SUCCESS = 'PROJECT_INFORMATION_LIST_SUCCESS'
export const PROJECT_INFORMATION_LIST_FAILURE = 'PROJECT_INFORMATION_LIST_FAILURE'
export const PROJECT_INFORMATION_LIST_RESET = 'PROJECT_INFORMATION_LIST_RESET'

export const PROJECT_INFORMATION_GET_REQUEST = 'PROJECT_INFORMATION_GET_REQUEST'
export const PROJECT_INFORMATION_GET_SUCCESS = 'PROJECT_INFORMATION_GET_SUCCESS'
export const PROJECT_INFORMATION_GET_FAILURE = 'PROJECT_INFORMATION_GET_FAILURE'
export const PROJECT_INFORMATION_GET_RESET = 'PROJECT_INFORMATION_GET_RESET'

export const PROJECT_INFORMATION_CREATE_REQUEST = 'PROJECT_INFORMATION_CREATE_REQUEST'
export const PROJECT_INFORMATION_CREATE_SUCCESS = 'PROJECT_INFORMATION_CREATE_SUCCESS'
export const PROJECT_INFORMATION_CREATE_FAILURE = 'PROJECT_INFORMATION_CREATE_FAILURE'
export const PROJECT_INFORMATION_CREATE_RESET = 'PROJECT_INFORMATION_CREATE_RESET'

export const PROJECT_INFORMATION_EDIT_REQUEST = 'PROJECT_INFORMATION_EDIT_REQUEST'
export const PROJECT_INFORMATION_EDIT_SUCCESS = 'PROJECT_INFORMATION_EDIT_SUCCESS'
export const PROJECT_INFORMATION_EDIT_FAILURE = 'PROJECT_INFORMATION_EDIT_FAILURE'
export const PROJECT_INFORMATION_EDIT_RESET = 'PROJECT_INFORMATION_EDIT_RESET'

export const PROJECT_INFORMATION_AUTO_ADD_REQUEST = 'PROJECT_INFORMATION_ADD_REQUEST'
export const PROJECT_INFORMATION_AUTO_ADD_SUCCESS = 'PROJECT_INFORMATION_AUTO_ADD_SUCCESS'
export const PROJECT_INFORMATION_AUTO_ADD_FAILURE = 'PROJECT_INFORMATION_AUTO_ADD_FAILURE'
export const PROJECT_INFORMATION_AUTO_ADD_RESET = 'PROJECT_INFORMATION_AUTO_ADD_RESET'

export const PROJECT_INFORMATION_AUTO_FILL_REQUEST = 'PROJECT_INFORMATION_AUTO_FILL_REQUEST'
export const PROJECT_INFORMATION_AUTO_FILL_SUCCESS = 'PROJECT_INFORMATION_AUTO_FILL_SUCCESS'
export const PROJECT_INFORMATION_AUTO_FILL_FAILURE = 'PROJECT_INFORMATION_AUTO_FILL_FAILURE'
export const PROJECT_INFORMATION_AUTO_FILL_RESET = 'PROJECT_INFORMATION_AUTO_FILL_RESET'

export const PROJECT_INFORMATION_CHANGE_STATUS_REQUEST = 'PROJECT_INFORMATION_CHANGE_STATUS_REQUEST'
export const PROJECT_INFORMATION_CHANGE_STATUS_SUCCESS = 'PROJECT_INFORMATION_CHANGE_STATUS_SUCCESS'
export const PROJECT_INFORMATION_CHANGE_STATUS_FAILURE = 'PROJECT_INFORMATION_CHANGE_STATUS_FAILURE'
export const PROJECT_INFORMATION_CHANGE_STATUS_RESET = 'PROJECT_INFORMATION_CHANGE_STATUS_RESET'

export const PROJECT_INFORMATION_SUBMIT_REQUEST = 'PROJECT_INFORMATION_SUBMIT_REQUEST'
export const PROJECT_INFORMATION_SUBMIT_SUCCESS = 'PROJECT_INFORMATION_SUBMIT_SUCCESS'
export const PROJECT_INFORMATION_SUBMIT_FAILURE = 'PROJECT_INFORMATION_SUBMIT_FAILURE'
export const PROJECT_INFORMATION_SUBMIT_RESET = 'PROJECT_INFORMATION_SUBMIT_RESET'

export const PROJECT_INFORMATION_CHECK_SUBMIT_REQUEST = 'PROJECT_INFORMATION_CHECK_SUBMIT_REQUEST'
export const PROJECT_INFORMATION_CHECK_SUBMIT_SUCCESS = 'PROJECT_INFORMATION_CHECK_SUBMIT_SUCCESS'
export const PROJECT_INFORMATION_CHECK_SUBMIT_FAILURE = 'PROJECT_INFORMATION_CHECK_SUBMIT_FAILURE'
export const PROJECT_INFORMATION_CHECK_SUBMIT_RESET = 'PROJECT_INFORMATION_CHECK_SUBMIT_RESET'

export const PROJECT_INFORMATION_APPROVE_REQUEST = 'PROJECT_INFORMATION_APPROVE_REQUEST'
export const PROJECT_INFORMATION_APPROVE_SUCCESS = 'PROJECT_INFORMATION_APPROVE_SUCCESS'
export const PROJECT_INFORMATION_APPROVE_FAILURE = 'PROJECT_INFORMATION_APPROVE_FAILURE'
export const PROJECT_INFORMATION_APPROVE_RESET = 'PROJECT_INFORMATION_APPROVE_RESET'

export const PROJECT_INFORMATION_EXPORT_REQUEST = 'PROJECT_INFORMATION_EXPORT_REQUEST'
export const PROJECT_INFORMATION_EXPORT_SUCCESS = 'PROJECT_INFORMATION_EXPORT_SUCCESS'
export const PROJECT_INFORMATION_EXPORT_FAILURE = 'PROJECT_INFORMATION_EXPORT_FAILURE'
export const PROJECT_INFORMATION_EXPORT_RESET = 'PROJECT_INFORMATION_EXPORT_RESET'

export const PROJECT_INFORMATION_SAVE_SNAPSHOT_REQUEST = 'PROJECT_INFORMATION_SAVE_SNAPSHOT_REQUEST'
export const PROJECT_INFORMATION_SAVE_SNAPSHOT_SUCCESS = 'PROJECT_INFORMATION_SAVE_SNAPSHOT_SUCCESS'
export const PROJECT_INFORMATION_SAVE_SNAPSHOT_FAILURE = 'PROJECT_INFORMATION_SAVE_SNAPSHOT_FAILURE'
export const PROJECT_INFORMATION_SAVE_SNAPSHOT_RESET = 'PROJECT_INFORMATION_SAVE_SNAPSHOT_RESET'

export const PROJECT_INFORMATION_GET_SNAPSHOT_REQUEST = 'PROJECT_INFORMATION_GET_SNAPSHOT_REQUEST'
export const PROJECT_INFORMATION_GET_SNAPSHOT_SUCCESS = 'PROJECT_INFORMATION_GET_SNAPSHOT_SUCCESS'
export const PROJECT_INFORMATION_GET_SNAPSHOT_FAILURE = 'PROJECT_INFORMATION_GET_SNAPSHOT_FAILURE'
export const PROJECT_INFORMATION_GET_SNAPSHOT_RESET = 'PROJECT_INFORMATION_GET_SNAPSHOT_RESET'

export const PROJECT_INFORMATION_OPEN_RESPONSE_MODAL = 'PROJECT_INFORMATION_OPEN_RESPONSE_MODAL'

export const REVENUE_PLANNING_SET_TABLE = 'REVENUE_PLANNING_SET_TABLE'
export const REVENUE_PLANNING_EDIT_TABLE = 'REVENUE_PLANNING_EDIT_TABLE'
export const REVENUE_PLANNING_SET_COMPLETE = 'REVENUE_PLANNING_SET_COMPLETE'

export const SHOW_MANUAL_PROJECT_INFORMATION = 'SHOW_MANUAL_PROJECT_INFORMATION'
export const CLOSE_MANUAL_PROJECT_INFORMATION = 'CLOSE_MANUAL_PROJECT_INFORMATION'
export const SET_TYPE_MANUAL_PROJECT_INFORMATION = 'SET_TYPE_MANUAL_PROJECT_INFORMATION'

export const SHOW_MANUAL_TIMESHEET = 'SHOW_MANUAL_TIMESHEET'
export const CLOSE_MANUAL_TIMESHEET = 'CLOSE_MANUAL_TIMESHEET'

export const SHOW_MANUAL_EFFICIENCY = 'SHOW_MANUAL_EFFICIENCY'
export const CLOSE_MANUAL_EFFICIENCY = 'CLOSE_MANUAL_EFFICIENCY'

export const TIMSHEET_STATUS_SET_OPTIONS = 'TIMSHEET_STATUS_SET_OPTIONS'

export const CLIENT_MASTER_LIST_REQUEST = 'CLIENT_MASTER_LIST_REQUEST'
export const CLIENT_MASTER_LIST_SUCCESS = 'CLIENT_MASTER_LIST_SUCCESS'
export const CLIENT_MASTER_LIST_FAILURE = 'CLIENT_MASTER_LIST_FAILURE'
export const CLIENT_MASTER_LIST_RESET = 'CLIENT_MASTER_LIST_RESET'

export const CLIENT_MASTER_CREATE_REQUEST = 'CLIENT_MASTER_CREATE_REQUEST'
export const CLIENT_MASTER_CREATE_SUCCESS = 'CLIENT_MASTER_CREATE_SUCCESS'
export const CLIENT_MASTER_CREATE_FAILURE = 'CLIENT_MASTER_CREATE_FAILURE'
export const CLIENT_MASTER_CREATE_RESET = 'CLIENT_MASTER_CREATE_RESET'

export const CLIENT_MASTER_GET_REQUEST = 'CLIENT_MASTER_GET_REQUEST'
export const CLIENT_MASTER_GET_SUCCESS = 'CLIENT_MASTER_GET_SUCCESS'
export const CLIENT_MASTER_GET_FAILURE = 'CLIENT_MASTER_GET_FAILURE'
export const CLIENT_MASTER_GET_RESET = 'CLIENT_MASTER_GET_RESET'

export const CLIENT_MASTER_EDIT_REQUEST = 'CLIENT_MASTER_EDIT_REQUEST'
export const CLIENT_MASTER_EDIT_SUCCESS = 'CLIENT_MASTER_EDIT_SUCCESS'
export const CLIENT_MASTER_EDIT_FAILURE = 'CLIENT_MASTER_EDIT_FAILURE'
export const CLIENT_MASTER_EDIT_RESET = 'CLIENT_MASTER_EDIT_RESET'

export const CLIENT_MASTER_DELETE_REQUEST = 'CLIENT_MASTER_DELETE_REQUEST'
export const CLIENT_MASTER_DELETE_SUCCESS = 'CLIENT_MASTER_DELETE_SUCCESS'
export const CLIENT_MASTER_DELETE_FAILURE = 'CLIENT_MASTER_DELETE_FAILURE'
export const CLIENT_MASTER_DELETE_RESET = 'CLIENT_MASTER_DELETE_RESET'

export const SUBCONTRACT_COST_GET_REQUEST = 'SUBCONTRACT_COST_GET_REQUEST'
export const SUBCONTRACT_COST_GET_SUCCESS = 'SUBCONTRACT_COST_GET_SUCCESS'
export const SUBCONTRACT_COST_GET_FAILURE = 'SUBCONTRACT_COST_GET_FAILURE'
export const SUBCONTRACT_COST_GET_RESET = 'SUBCONTRACT_COST_GET_RESET'

export const SUBCONTRACT_COST_CREATE_REQUEST = 'SUBCONTRACT_COST_CREATE_REQUEST'
export const SUBCONTRACT_COST_CREATE_SUCCESS = 'SUBCONTRACT_COST_CREATE_SUCCESS'
export const SUBCONTRACT_COST_CREATE_FAILURE = 'SUBCONTRACT_COST_CREATE_FAILURE'
export const SUBCONTRACT_COST_CREATE_RESET = 'SUBCONTRACT_COST_CREATE_RESET'

export const SUBCONTRACT_COST_EDIT_REQUEST = 'SUBCONTRACT_COST_EDIT_REQUEST'
export const SUBCONTRACT_COST_EDIT_SUCCESS = 'SUBCONTRACT_COST_EDIT_SUCCESS'
export const SUBCONTRACT_COST_EDIT_FAILURE = 'SUBCONTRACT_COST_EDIT_FAILURE'
export const SUBCONTRACT_COST_EDIT_RESET = 'SUBCONTRACT_COST_EDIT_RESET'

export const SUBCONTRACT_COST_EXPORT_REQUEST = 'SUBCONTRACT_COST_EXPORT_REQUEST'
export const SUBCONTRACT_COST_EXPORT_SUCCESS = 'SUBCONTRACT_COST_EXPORT_SUCCESS'
export const SUBCONTRACT_COST_EXPORT_FAILURE = 'SUBCONTRACT_COST_EXPORT_FAILURE'
export const SUBCONTRACT_COST_EXPORT_RESET = 'SUBCONTRACT_COST_EXPORT_RESET'

export const STANDARD_COST_PRICE_GET_REQUEST = 'STANDARD_COST_PRICE_GET_REQUEST'
export const STANDARD_COST_PRICE_GET_SUCCESS = 'STANDARD_COST_PRICE_GET_SUCCESS'
export const STANDARD_COST_PRICE_GET_FAILURE = 'STANDARD_COST_PRICE_GET_FAILURE'
export const STANDARD_COST_PRICE_GET_RESET = 'STANDARD_COST_PRICE_GET_RESET'

export const STANDARD_COST_PRICE_CREATE_REQUEST = 'STANDARD_COST_PRICE_CREATE_REQUEST'
export const STANDARD_COST_PRICE_CREATE_SUCCESS = 'STANDARD_COST_PRICE_CREATE_SUCCESS'
export const STANDARD_COST_PRICE_CREATE_FAILURE = 'STANDARD_COST_PRICE_CREATE_FAILURE'
export const STANDARD_COST_PRICE_CREATE_RESET = 'STANDARD_COST_PRICE_CREATE_RESET'

export const STANDARD_COST_PRICE_EDIT_REQUEST = 'STANDARD_COST_PRICE_EDIT_REQUEST'
export const STANDARD_COST_PRICE_EDIT_SUCCESS = 'STANDARD_COST_PRICE_EDIT_SUCCESS'
export const STANDARD_COST_PRICE_EDIT_FAILURE = 'STANDARD_COST_PRICE_EDIT_FAILURE'
export const STANDARD_COST_PRICE_EDIT_RESET = 'STANDARD_COST_PRICE_EDIT_RESET'

export const STANDARD_COST_PRICE_EXPORT_REQUEST = 'STANDARD_COST_PRICE_EXPORT_REQUEST'
export const STANDARD_COST_PRICE_EXPORT_SUCCESS = 'STANDARD_COST_PRICE_EXPORT_SUCCESS'
export const STANDARD_COST_PRICE_EXPORT_FAILURE = 'STANDARD_COST_PRICE_EXPORT_FAILURE'
export const STANDARD_COST_PRICE_EXPORT_RESET = 'STANDARD_COST_PRICE_EXPORT_RESET'

export const TIMESHEET_GET_REQUEST = 'TIMESHEET_GET_REQUEST'
export const TIMESHEET_GET_SUCCESS = 'TIMESHEET_GET_SUCCESS'
export const TIMESHEET_GET_FAILURE = 'TIMESHEET_GET_FAILURE'
export const TIMESHEET_GET_RESET = 'TIMESHEET_GET_RESET'

export const TIMESHEET_EDIT_REQUEST = 'TIMESHEET_EDIT_REQUEST'
export const TIMESHEET_EDIT_SUCCESS = 'TIMESHEET_EDIT_SUCCESS'
export const TIMESHEET_EDIT_FAILURE = 'TIMESHEET_EDIT_FAILURE'
export const TIMESHEET_EDIT_RESET = 'TIMESHEET_EDIT_RESET'

export const MY_TIMESHEET_GET_REQUEST = 'MY_TIMESHEET_GET_REQUEST'
export const MY_TIMESHEET_GET_SUCCESS = 'MY_TIMESHEET_GET_SUCCESS'
export const MY_TIMESHEET_GET_FAILURE = 'MY_TIMESHEET_GET_FAILURE'
export const MY_TIMESHEET_GET_RESET = 'MY_TIMESHEET_GET_RESET'
export const MY_TIMESHEET_SET_INVALID_INPUT = 'MY_TIMESHEET_SET_INVALID_INPUT'
export const MY_TIMESHEET_RESET_INVALID_INPUT = 'MY_TIMESHEET_RESET_INVALID_INPUT'

export const TIMESHEET_GET_PROJECTS_REQUEST = 'TIMESHEET_GET_PROJECTS_REQUEST'
export const TIMESHEET_GET_PROJECTS_SUCCESS = 'TIMESHEET_GET_PROJECTS_SUCCESS'
export const TIMESHEET_GET_PROJECTS_FAILURE = 'TIMESHEET_GET_PROJECTS_FAILURE'
export const TIMESHEET_GET_PROJECTS_RESET = 'TIMESHEET_GET_PROJECTS_RESET'

export const TIMESHEET_SUBMIT_REQUEST = 'TIMESHEET_SUBMIT_REQUEST'
export const TIMESHEET_SUBMIT_SUCCESS = 'TIMESHEET_SUBMIT_SUCCESS'
export const TIMESHEET_SUBMIT_FAILURE = 'TIMESHEET_SUBMIT_FAILURE'
export const TIMESHEET_SUBMIT_RESET = 'TIMESHEET_SUBMIT_RESET'

export const TIMESHEET_STATUS_REQUEST = 'TIMESHEET_STATUS_REQUEST'
export const TIMESHEET_STATUS_SUCCESS = 'TIMESHEET_STATUS_SUCCESS'
export const TIMESHEET_STATUS_FAILURE = 'TIMESHEET_STATUS_FAILURE'
export const TIMESHEET_STATUS_RESET = 'TIMESHEET_STATUS_RESET'

export const TIMESHEET_REQUEST_GET_REQUEST = 'TIMESHEET_REQUEST_GET_REQUEST'
export const TIMESHEET_REQUEST_GET_SUCCESS = 'TIMESHEET_REQUEST_GET_SUCCESS'
export const TIMESHEET_REQUEST_GET_FAILURE = 'TIMESHEET_REQUEST_GET_FAILURE'
export const TIMESHEET_REQUEST_GET_RESET = 'TIMESHEET_REQUEST_GET_RESET'

export const TIMESHEET_REDIRECT_SET = 'TIMESHEET_REDIRECT_SET'

export const TIMESHEET_APPROVE_REQUEST = 'TIMESHEET_APPROVE_REQUEST'
export const TIMESHEET_APPROVE_SUCCESS = 'TIMESHEET_APPROVE_SUCCESS'
export const TIMESHEET_APPROVE_FAILURE = 'TIMESHEET_APPROVE_FAILURE'
export const TIMESHEET_APPROVE_RESET = 'TIMESHEET_APPROVE_RESET'

export const TIMESHEET_CANCEL_REQUEST = 'TIMESHEET_CANCEL_REQUEST'
export const TIMESHEET_CANCEL_SUCCESS = 'TIMESHEET_CANCEL_SUCCESS'
export const TIMESHEET_CANCEL_FAILURE = 'TIMESHEET_CANCEL_FAILURE'
export const TIMESHEET_CANCEL_RESET = 'TIMESHEET_CANCEL_RESET'

export const TIMESHEET_EXPORT_REQUEST = 'TIMESHEET_EXPORT_REQUEST'
export const TIMESHEET_EXPORT_SUCCESS = 'TIMESHEET_EXPORT_SUCCESS'
export const TIMESHEET_EXPORT_FAILURE = 'TIMESHEET_EXPORT_FAILURE'
export const TIMESHEET_EXPORT_RESET = 'TIMESHEET_EXPORT_RESET'

export const MY_TIMESHEET_EXPORT_REQUEST = 'MY_TIMESHEET_EXPORT_REQUEST'
export const MY_TIMESHEET_EXPORT_SUCCESS = 'MY_TIMESHEET_EXPORT_SUCCESS'
export const MY_TIMESHEET_EXPORT_FAILURE = 'MY_TIMESHEET_EXPORT_FAILURE'
export const MY_TIMESHEET_EXPORT_RESET = 'MY_TIMESHEET_EXPORT_RESET'

export const EFFICIENCY_GET_REQUEST = 'EFFICIENCY_GET_REQUEST'
export const EFFICIENCY_GET_SUCCESS = 'EFFICIENCY_GET_SUCCESS'
export const EFFICIENCY_GET_FAILURE = 'EFFICIENCY_GET_FAILURE'
export const EFFICIENCY_GET_RESET = 'EFFICIENCY_GET_RESET'

export const EFFICIENCY_LOB_GET_REQUEST = 'EFFICIENCY_LOB_GET_REQUEST'
export const EFFICIENCY_LOB_GET_SUCCESS = 'EFFICIENCY_LOB_GET_SUCCESS'
export const EFFICIENCY_LOB_GET_FAILURE = 'EFFICIENCY_LOB_GET_FAILURE'
export const EFFICIENCY_LOB_GET_RESET = 'EFFICIENCY_LOB_GET_RESET'

export const EFFICIENCY_LOB_EXPORT_REQUEST = 'EFFICIENCY_LOB_EXPORT_REQUEST'
export const EFFICIENCY_LOB_EXPORT_SUCCESS = 'EFFICIENCY_LOB_EXPORT_SUCCESS'
export const EFFICIENCY_LOB_EXPORT_FAILURE = 'EFFICIENCY_LOB_EXPORT_FAILURE'
export const EFFICIENCY_LOB_EXPORT_RESET = 'EFFICIENCY_LOB_EXPORT_RESET'

export const EFFICIENCY_EDIT_REQUEST = 'EFFICIENCY_EDIT_REQUEST'
export const EFFICIENCY_EDIT_SUCCESS = 'EFFICIENCY_EDIT_SUCCESS'
export const EFFICIENCY_EDIT_FAILURE = 'EFFICIENCY_EDIT_FAILURE'
export const EFFICIENCY_EDIT_RESET = 'EFFICIENCY_EDIT_RESET'

export const EFFICIENCY_SUBMIT_REQUEST = 'EFFICIENCY_SUBMIT_REQUEST'
export const EFFICIENCY_SUBMIT_SUCCESS = 'EFFICIENCY_SUBMIT_SUCCESS'
export const EFFICIENCY_SUBMIT_FAILURE = 'EFFICIENCY_SUBMIT_FAILURE'
export const EFFICIENCY_SUBMIT_RESET = 'EFFICIENCY_SUBMIT_RESET'

export const COMPENSATE_REQUEST_GET_REQUEST = 'COMPENSATE_REQUEST_GET_REQUEST'
export const COMPENSATE_REQUEST_GET_SUCCESS = 'COMPENSATE_REQUEST_GET_SUCCESS'
export const COMPENSATE_REQUEST_GET_FAILURE = 'COMPENSATE_REQUEST_GET_FAILURE'
export const COMPENSATE_REQUEST_GET_RESET = 'COMPENSATE_REQUEST_GET_RESET'

export const COMPENSATE_REQUEST_CREATE_REQUEST = 'COMPENSATE_REQUEST_CREATE_REQUEST'
export const COMPENSATE_REQUEST_CREATE_SUCCESS = 'COMPENSATE_REQUEST_CREATE_SUCCESS'
export const COMPENSATE_REQUEST_CREATE_FAILURE = 'COMPENSATE_REQUEST_CREATE_FAILURE'
export const COMPENSATE_REQUEST_CREATE_RESET = 'COMPENSATE_REQUEST_CREATE_RESET'

export const COMPENSATE_REQUEST_PREVIEW_REQUEST = 'COMPENSATE_REQUEST_PREVIEW_REQUEST'
export const COMPENSATE_REQUEST_PREVIEW_SUCCESS = 'COMPENSATE_REQUEST_PREVIEW_SUCCESS'
export const COMPENSATE_REQUEST_PREVIEW_FAILURE = 'COMPENSATE_REQUEST_PREVIEW_FAILURE'
export const COMPENSATE_REQUEST_PREVIEW_RESET = 'COMPENSATE_REQUEST_PREVIEW_RESET'

export const COMPENSATE_REQUEST_APPROVE_REQUEST = 'COMPENSATE_REQUEST_APPROVE_REQUEST'
export const COMPENSATE_REQUEST_APPROVE_SUCCESS = 'COMPENSATE_REQUEST_APPROVE_SUCCESS'
export const COMPENSATE_REQUEST_APPROVE_FAILURE = 'COMPENSATE_REQUEST_APPROVE_FAILURE'
export const COMPENSATE_REQUEST_APPROVE_RESET = 'COMPENSATE_REQUEST_APPROVE_RESET'

export const COMPENSATE_REQUEST_CANCEL_REQUEST = 'COMPENSATE_REQUEST_CANCEL_REQUEST'
export const COMPENSATE_REQUEST_CANCEL_SUCCESS = 'COMPENSATE_REQUEST_CANCEL_SUCCESS'
export const COMPENSATE_REQUEST_CANCEL_FAILURE = 'COMPENSATE_REQUEST_CANCEL_FAILURE'
export const COMPENSATE_REQUEST_CANCEL_RESET = 'COMPENSATE_REQUEST_CANCEL_RESET'

export const CONSENT_MANAGEMENT_LIST_REQUEST = 'CONSENT_MANAGEMENT_LIST_REQUEST'
export const CONSENT_MANAGEMENT_LIST_SUCCESS = 'CONSENT_MANAGEMENT_LIST_SUCCESS'
export const CONSENT_MANAGEMENT_LIST_FAILURE = 'CONSENT_MANAGEMENT_LIST_FAILURE'
export const CONSENT_MANAGEMENT_LIST_RESET = 'CONSENT_MANAGEMENT_LIST_RESET'

export const CONSENT_MANAGEMENT_CREATE_REQUEST = 'CONSENT_MANAGEMENT_CREATE_REQUEST'
export const CONSENT_MANAGEMENT_CREATE_SUCCESS = 'CONSENT_MANAGEMENT_CREATE_SUCCESS'
export const CONSENT_MANAGEMENT_CREATE_FAILURE = 'CONSENT_MANAGEMENT_CREATE_FAILURE'
export const CONSENT_MANAGEMENT_CREATE_RESET = 'CONSENT_MANAGEMENT_CREATE_RESET'

export const CONSENT_MANAGEMENT_DEACTIVATE_REQUEST = 'CONSENT_MANAGEMENT_DEACTIVATE_REQUEST'
export const CONSENT_MANAGEMENT_DEACTIVATE_SUCCESS = 'CONSENT_MANAGEMENT_DEACTIVATE_SUCCESS'
export const CONSENT_MANAGEMENT_DEACTIVATE_FAILURE = 'CONSENT_MANAGEMENT_DEACTIVATE_FAILURE'
export const CONSENT_MANAGEMENT_DEACTIVATE_RESET = 'CONSENT_MANAGEMENT_DEACTIVATE_RESET'

export const CONSENT_MANAGEMENT_EDIT_REQUEST = 'CONSENT_MANAGEMENT_EDIT_REQUEST'
export const CONSENT_MANAGEMENT_EDIT_SUCCESS = 'CONSENT_MANAGEMENT_EDIT_SUCCESS'
export const CONSENT_MANAGEMENT_EDIT_FAILURE = 'CONSENT_MANAGEMENT_EDIT_FAILURE'
export const CONSENT_MANAGEMENT_EDIT_RESET = 'CONSENT_MANAGEMENT_EDIT_RESET'

export const CONSENT_MANAGEMENT_EXPORT_REQUEST = 'CONSENT_MANAGEMENT_EXPORT_REQUEST'
export const CONSENT_MANAGEMENT_EXPORT_SUCCESS = 'CONSENT_MANAGEMENT_EXPORT_SUCCESS'
export const CONSENT_MANAGEMENT_EXPORT_FAILURE = 'CONSENT_MANAGEMENT_EXPORT_FAILURE'
export const CONSENT_MANAGEMENT_EXPORT_RESET = 'CONSENT_MANAGEMENT_EXPORT_RESET'

export const CONSENT_MANAGEMENT_GET_REQUEST = 'CONSENT_MANAGEMENT_GET_REQUEST'
export const CONSENT_MANAGEMENT_GET_SUCCESS = 'CONSENT_MANAGEMENT_GET_SUCCESS'
export const CONSENT_MANAGEMENT_GET_FAILURE = 'CONSENT_MANAGEMENT_GET_FAILURE'
export const CONSENT_MANAGEMENT_GET_RESET = 'CONSENT_MANAGEMENT_GET_RESET'

export const CONSENT_LOG_GET_REQUEST = 'CONSENT_LOG_GET_REQUEST'
export const CONSENT_LOG_GET_SUCCESS = 'CONSENT_LOG_GET_SUCCESS'
export const CONSENT_LOG_GET_FAILURE = 'CONSENT_LOG_GET_FAILURE'
export const CONSENT_LOG_GET_RESET = 'CONSENT_LOG_GET_RESET'

export const CONSENT_LOG_ACTIVATE_REQUEST = 'CONSENT_LOG_ACTIVATE_REQUEST'
export const CONSENT_LOG_ACTIVATE_SUCCESS = 'CONSENT_LOG_ACTIVATE_SUCCESS'
export const CONSENT_LOG_ACTIVATE_FAILURE = 'CONSENT_LOG_ACTIVATE_FAILURE'
export const CONSENT_LOG_ACTIVATE_RESET = 'CONSENT_LOG_ACTIVATE_RESET'

export const CONSENT_LOG_CREATE_REQUEST = 'CONSENT_LOG_CREATE_REQUEST'
export const CONSENT_LOG_CREATE_SUCCESS = 'CONSENT_LOG_CREATE_SUCCESS'
export const CONSENT_LOG_CREATE_FAILURE = 'CONSENT_LOG_CREATE_FAILURE'
export const CONSENT_LOG_CREATE_RESET = 'CONSENT_LOG_CREATE_RESET'

export const COONSENT_LOG_DEACTIVATE_REQUEST = 'COONSENT_LOG_DEACTIVATE_REQUEST'
export const COONSENT_LOG_DEACTIVATE_SUCCESS = 'COONSENT_LOG_DEACTIVATE_SUCCESS'
export const COONSENT_LOG_DEACTIVATE_FAILURE = 'COONSENT_LOG_DEACTIVATE_FAILURE'
export const COONSENT_LOG_DEACTIVATE_RESET = 'COONSENT_LOG_DEACTIVATE_RESET'

export const TEAM_CALENDAR_GET_REQUEST = 'TEAM_CALENDAR_GET_REQUEST'
export const TEAM_CALENDAR_GET_SUCCESS = 'TEAM_CALENDAR_GET_SUCCESS'
export const TEAM_CALENDAR_GET_FAILURE = 'TEAM_CALENDAR_GET_FAILURE'
export const TEAM_CALENDAR_SET_ITEMS = 'TEAM_CALENDAR_SET_ITEMS'
export const TEAM_CALENDAR_SET_MOMENT = 'TEAM_CALENDAR_SET_MOMENT'
export const TEAM_CALENDAR_SET_RANGE = 'TEAM_CALENDAR_SET_RANGE'
export const TEAM_CALENDAR_SET_SEARCH = 'TEAM_CALENDAR_SET_SEARCH'
export const TEAM_CALENDAR_SET_TAB = 'TEAM_CALENDAR_SET_TAB'

export const PPS_ALERT = {
  NOT_SUBMIT_INFO: 'NOT_SUBMIT_INFO',
  SUBMIT_PROFIT: 'SUBMIT_PROFIT',
}

export const PPS_CHANGE_DISPLAY_TAB = 'PPS_CHANGE_DISPLAY_TAB'
export const PPS_SET_SUBMIT_MONTH = 'PPS_SET_SUBMIT_MONTH'

export const PPS_SET_OTHER_COST = 'PPS_SET_OTHER_COST'

export const PPS_SET_OTHER_COST_EDITING = 'PPS_SET_OTHER_COST_EDITING'
export const PPS_RESET_OTHER_COST_EDITING = 'PPS_RESET_OTHER_COST_EDITING'
export const PPS_SET_PERCENT_TABLE_EXPAND = 'PPS_SET_PERCENT_TABLE_EXPAND'
export const PPS_CAN_SAVE_PROGRESS = 'PPS_CAN_SAVE_PROGRESS'

export const PPS_IS_FETCHING = 'PPS_IS_FETCHING'

export const PPS_RESET_ALERT = 'PPS_RESET_ALERT'

export const PPS_FETCH_PROJECTS_SUCCESS = 'PPS_FETCH_PROJECTS_SUCCESS'
export const PPS_FETCH_PROJECTS_FAILURE = 'PPS_FETCH_PROJECTS_FAILURE'

export const PPS_FETCH_PROFIT_SUCCESS = 'PPS_FETCH_PROFIT_SUCCESS'
export const PPS_FETCH_PROFIT_FAILURE = 'PPS_FETCH_PROFIT_FAILURE'

export const PPS_UPDATE_PROFIT_SUCCESS = 'PPS_UPDATE_PROFIT_SUCCESS'
export const PPS_UPDATE_PROFIT_FAILURE = 'PPS_UPDATE_PROFIT_FAILURE'

export const PPS_DELETE_IMPORT_SUCCESS = 'PPS_DELETE_IMPORT_SUCCESS'
export const PPS_DELETE_IMPORT_FAILURE = 'PPS_DELETE_IMPORT_FAILURE'

export const PPS_SUBMIT_PROFIT_SUCCESS = 'PPS_SUBMIT_PROFIT_SUCCESS'
export const PPS_SUBMIT_PROFIT_FAILURE = 'PPS_SUBMIT_PROFIT_FAILURE'

export const PPS_IMPORT_ACTUAL_REQUEST = 'PPS_IMPORT_ACTUAL_REQUEST'
export const PPS_IMPORT_ACTUAL_SUCCESS = 'PPS_IMPORT_ACTUAL_SUCCESS'
export const PPS_IMPORT_ACTUAL_FAILURE = 'PPS_IMPORT_ACTUAL_FAILURE'
export const PPS_IMPORT_ACTUAL_CLEAR = 'PPS_IMPORT_ACTUAL_CLEAR'

export const PPS_IMPORT_DETAIL_SUCCESS = 'PPS_IMPORT_DETAIL_SUCCESS'
export const PPS_IMPORT_DETAIL_FAILURE = 'PPS_IMPORT_DETAIL_FAILURE'
export const PPS_IMPORT_DETAIL_CLEAR = 'PPS_IMPORT_DETAIL_CLEAR'

export const PPS_GET_PROJECT_PROGRESS_REQUEST = 'PPS_GET_PROJECT_PROGRESS_REQUEST'
export const PPS_GET_PROJECT_PROGRESS_SUCCESS = 'PPS_GET_PROJECT_PROGRESS_SUCCESS'
export const PPS_GET_PROJECT_PROGRESS_FAILURE = 'PPS_GET_PROJECT_PROGRESS_FAILURE'
export const PPS_GET_PROJECT_PROGRESS_CLEAR = 'PPS_GET_PROJECT_PROGRESS_CLEAR'

export const PPS_EDIT_PROJECT_PROGRESS_REQUEST = 'PPS_EDIT_PROJECT_PROGRESS_REQUEST'
export const PPS_EDIT_PROJECT_PROGRESS_SUCCESS = 'PPS_EDIT_PROJECT_PROGRESS_SUCCESS'
export const PPS_EDIT_PROJECT_PROGRESS_FAILURE = 'PPS_EDIT_PROJECT_PROGRESS_FAILURE'
export const PPS_EDIT_PROJECT_PROGRESS_CLEAR = 'PPS_EDIT_PROJECT_PROGRESS_CLEAR'

export const PPS_MANUAL_OPEN = 'PPS_MANUAL_OPEN'
export const PPS_MANUAL_CLOSE = 'PPS_MANUAL_CLOSE'
export const PPPS_OPEN_RESPONSE_MODAL = 'PPPS_OPEN_RESPONSE_MODAL'

export const THB_SHORT = n => `฿${abbreviateNumber(n)}`
export const THB_FULL = n => `฿${financialFormatter(n)}`

export const url = 'https://www.materialui.co/materialIcons/navigation/cancel_black_192x192.png'
export const leave_entitlement_table_header = [
  'Start Date',
  'End Date',
  'Entitlement ID',
  'Entitlement Name',
  'Entitlement Total Default',
]
export const leave_type_table_header = ['Start Date', 'End Date', 'Leave ID', 'Leave Type Name']

export const client_master_header = [
  { label: 'Client ID', value: 0 },
  { label: 'Client Name', value: 1 },
  { label: 'Contact Name', value: 2 },
  { label: 'Contact Position', value: 3 },
]

export const holiday_table_header = [
  { label: 'Year', value: 0 },
  { label: 'Start Date', value: 1 },
  { label: 'Holiday Name', value: 2 },
]
export const inbox_table_header = [
  { label: 'Status', value: 0 },
  { label: 'Start Date', value: 2 },
  { label: 'End Date', value: 8 },
  { label: 'Employee ID', value: 1 },
  { label: 'LOB', value: 3 },
  { label: 'Employee Name', value: 4 },
  { label: 'Nick Name', value: 5 },
  { label: 'Position', value: 6 },
  { label: 'Request Type', value: 7 },
]
export const leave_history_table_header = [
  { label: 'Status', value: 0 },
  { label: 'Request Type', value: 1 },
  { label: 'Duration', value: 2 },
  { label: 'Total Leave Day', value: 3 },
  { label: 'Approver', value: 4 },
  { label: 'Submit Date', value: 5 },
]
export const leave_generation_table_header = [
  { label: 'Employee ID', value: 0 },
  { label: 'Company Name', value: 1 },
  { label: 'LOB', value: 2 },
  { label: 'Employee Name', value: 3 },
]
export const time_sheet_status_header = [
  { label: 'Timesheet Status', value: 0 },
  { label: 'By', value: 1 },
  { label: 'Period', value: 2 },
  { label: 'Employee ID', value: 3 },
  { label: 'Employee Name', value: 4 },
  { label: 'LOB', value: 5 },
  { label: 'Department', value: 6 },
]
export const time_sheet_approval_header = [
  { label: 'My Approve Status', value: 8 },
  { label: 'Timesheet Status', value: 0 },
  { label: 'Month', value: 1 },
  { label: 'Year', value: 2 },
  { label: 'Employee ID', value: 3 },
  { label: 'Employee Name', value: 4 },
  { label: 'LOB', value: 5 },
  { label: 'Department', value: 6 },
  { label: 'Submitted Date', value: 7 },
]
export const year_of_service_table_header = [
  { label: 'Employee ID', value: 0 },
  { label: 'Employee Name', value: 1 },
  { label: 'Company', value: 2 },
  { label: 'LOB', value: 3 },
  { label: 'Department', value: 4 },
  { label: 'Hiring Date', value: 5 },
  { label: 'Year of Service', value: 6 },
]
export const status = [{ label: 'Active', value: true }, { label: 'Inactive', value: false }]
export const title = [
  { label: 'Choose title', value: '' },
  { label: 'Mr.', value: 'Mr.' },
  { label: 'Mrs.', value: 'Mrs.' },
  { label: 'Ms.', value: 'Ms.' },
]
export const title_th = [
  { label: 'Choose title', value: '' },
  { label: 'นาย', value: 'นาย' },
  { label: 'นางสาว', value: 'นางสาว' },
  { label: 'นาง', value: 'นาง' },
  { label: 'ว่าที่ร.ต.', value: 'ว่าที่ร.ต.' },
  { label: 'ว่าที่ร.ต.หญิง', value: 'ว่าที่ร.ต.หญิง' },
]
export const counting = [
  { label: 'Calendar Day', value: true },
  { label: 'Working Day', value: false },
]
export const sequence = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
]
export const leave_time = [
  { label: 'Full-Day', value: 'FULLDAY' },
  { label: 'AM', value: 'AM' },
  { label: 'PM', value: 'PM' },
]
export const leave_status = [
  { label: 'Status', value: '' },
  { label: 'Approved', value: 'APPROVED' },
  { label: 'Pending', value: 'PENDING' },
  { label: 'Pending_HR', value: 'PENDING_HR' },
  { label: 'Rejected', value: 'REJECTED' },
  { label: 'Cancel', value: 'CANCEL' },
]
export const customStyles = {
  option: (base, state) => ({
    ...base,
    background: state.isFocused ? '#007bff' : '#FFFFFF',
    color: state.isFocused ? 'white' : 'black',
  }),
  menu: (base, state) => ({
    ...base,
    background: state.isDisabled ? '#e9ecef' : '#FFFFFF',
    padding: 0,
  }),
  control: (base, state) => ({
    ...base,
    background: state.isDisabled ? '#e9ecef' : '#FFFFFF',
  }),
}

export const invalidStyles = {
  control: (base, state) => ({
    ...base,
    border: !state.isFocused ? '1px solid #dc3545' : '',
    background: '#FFFFFF',
  }),
}



// WEBPACK FOOTER //
// ./src/constants/index.js